module.exports = __webpack_public_path__ + "static/img/hotel.bd36427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/hotel.png
// module id = fLfL
// module chunks = 1